import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      gridArea: 'required',
    },
  },
  title: {
    color: theme.palette.secondary.dark,
    marginBottom: 16,
  },
}))

export default useStyles
